import React from "react";

const AgentV2 = (props) => {
  const agent = props.agent;
  let layoutIsMin = props.layoutIsMin;

  if (layoutIsMin) {
    return (
      <div className="print-agent-info">
        <div className="print-agent-name">{agent.name}</div>
        <div className="print-agent-title">
          {agent.title ? `, ${agent.title}` : null}
        </div>
        <break></break>
        <div className="print-agent-email">{`${agent.email} |\u00A0`}</div>
        <div className="print-agent-phone">
          {`${agent.mobilePhone ? "m: " + agent.mobilePhone : ""} ${
            agent.officePhone !== agent.mobilePhone
              ? " | o: " + agent.officePhone
              : ""
          } `}
          <div className="print-agent-website">{`${
            agent.websiteUrl
              ? " | " +
                agent.websiteUrl
                  .replace("www.", "")
                  .replace(/(^\w+:|^)\/\//, "")
              : ""
          }`}</div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="print-agent-info imgAlign">
        <div className="print-agent-image">
          <img src={agent.imageSrc} alt={agent.name}></img>
        </div>
        <div className="print-info-w-image">
          <div className="print-agent-name">{agent.name}</div>
          <div className="print-agent-title">
            {agent.title ? agent.title : null}
          </div>
          <div className="print-agent-email">{agent.email}</div>
          <div className="print-agent-phone">
            {`${agent.mobilePhone ? "m: " + agent.mobilePhone : ""} ${
              agent.officePhone !== agent.mobilePhone
                ? " | o: " + agent.officePhone
                : ""
            } `}
            <div className="print-agent-website">{`${
              agent.websiteUrl
                ? " | " +
                  agent.websiteUrl
                    .replace("www.", "")
                    .replace(/(^\w+:|^)\/\//, "")
                : ""
            }`}</div>
          </div>
        </div>
      </div>
    );
  }
};

export default AgentV2;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/agentv2.js